// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import Description from '../../ui-helper-elements/Description'
// JS Imports
//@ts-ignore
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function EstimatedAnnualCost() {
   const state = useQuoteContext()
   const { getString } = state
   const AnnualHoverDisclaimer = state.getString(
      'product.EstimatedAnnualCost.Description.Content.Disclaimer',
   )
   const AnnualHoverBundleDisclaimer = state.getString(
      'product.EstimatedAnnualCost.Description.Content.BundleDisclaimer',
   )
   const AnnualHoverProrationDisclaimer = state.getString(
      'product.EstimatedAnnualCost.Description.Content.ProrationDisclaimer',
   )

   const isProrated = state.proratedActivationDetails.prorated
   const hasBundleDiscount = state.discountBundle

   if (state.user_view == 'Internal' || state.totalDueAtActivation > 0)
      return (
         <div className='row'>
            <div className='col-bhr1 col-bhr5'>
               {getString('product.EstimatedAnnualCost.Title')}
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <Description
               className='col'
               title='Estimated Annual Cost'
               content={
                  <>
                     {AnnualHoverDisclaimer}
                     <br />
                     {isProrated && (
                        <>
                           <span className='EstimatedAnnualHoverDisclaimer'>
                              {AnnualHoverProrationDisclaimer}
                           </span>
                           <br />
                        </>
                     )}
                     {hasBundleDiscount && (
                        <>
                           <span className='EstimatedAnnualHoverDisclaimer'>
                              {AnnualHoverBundleDisclaimer}
                           </span>
                        </>
                     )}
                  </>
               }
            >
               <span className='hoverable'>
                  {formatFloatAsCurrencySymbol(
                     state.annualTotal.totalPrice,
                     state.currencyObject,
                  )}
               </span>
            </Description>
         </div>
      )
}
